/* eslint-disable no-unused-vars */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import { Button, HeadingText } from '@paypalcorp/pp-react';
import { Message } from '@paypalcorp/worldready-react';
import { CONTACT_TOPIC_TREE_INTENTS } from '../../common/storeConstants';
import { changeSelected } from './TopicIntents-Actions';
import { trackClickEvent } from '../../helpers/analytics/fptiHelper';
import { FPTI_DATA } from '../../common/propTypes';
import TopicIntentIcon from './TopicIntentIcon';

const TopicIntentFinalSelectionBar = function (props) {
  const dispatch = useDispatch();
  const { isLoading, isError, selectedFinalIntent } = useSelector((state) => state[CONTACT_TOPIC_TREE_INTENTS]);
  const { FPTIData } = props;

  // TODO: whenever change topic, fire reset actions for pages which have data dependencies
  const handleChangeTopicIntentEvent = (e) => {
    e.preventDefault();
    trackClickEvent({ ...FPTIData.topicTreeFinalIntentChangeRequested });
    // fire change selected intent action
    dispatch(changeSelected());
  };

  const renderFinalSelect = () => {
    return (
      <div className="sh_topic_intent__final_selection" data-testid="sh-topic-intent-final-selection">
        <div
          className="sh_topic_intent__final_selection_text_content"
          data-testid="sh-topic-intent-final-selection-text-content"
        >
          <TopicIntentIcon
            refId={selectedFinalIntent.ref_id}
            className="sh_topic_intent__final_selection__icon sh_topic_intent__blob_icons"
            dataTestId="sh-topic-intent-final-selection-icon"
          />
          <HeadingText
            size="sm"
            className="sh_topic_intent__final_selection__heading_text"
            data-testid="sh-topic-intent-final-selection-heading-text"
          >
            {selectedFinalIntent.topic_name}
          </HeadingText>
        </div>
        <Button
          size="sm"
          secondary
          onClick={(e) => handleChangeTopicIntentEvent(e)}
          className="sh_contact_option__button sh_topic_intent__final_selection_btn"
          data-testid="sh-topic-intent-final-selection-btn"
        >
          <Message id="smarthelp.app.topic.finalselection.button.label" />
        </Button>
      </div>
    );
  };

  if (!_isEmpty(selectedFinalIntent) && !isLoading && !isError) {
    return (
      <div
        className="sh_topic_intent__final_selection_container"
        data-testid="sh-topic-intent-final-selection-container"
      >
        {renderFinalSelect()}
      </div>
    );
  }

  return null;
};

TopicIntentFinalSelectionBar.propTypes = {
  FPTIData: PropTypes.shape(FPTI_DATA).isRequired,
};

export default TopicIntentFinalSelectionBar;
